import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Subtitle, Description, Titlespan2 } from "../../components/common/title/index";
import ProductsData from "../../data/products/index";
import VariantProductCard from "../../components/VariantProductCard";
import "./products.scss";

export default function Products() {
  return (
    <section className="products-wrapper" id="products">
      <Container>
        <div className="main-title-wrapper">
          <Subtitle Class="site-subtitle" Name="SHOP FEATURED" />
          <Titlespan2 Class="sitemain-subtitle" Name="New & Popular" Label="Products" />
          <Description
            Class="site-dec"
            Name="Hand-picked items with quick color and size selection."
          />
        </div>

        <Row>
          {ProductsData.slice(0, 3).map(p => (
            <Col lg={4} sm={6} key={p.id}>
              <VariantProductCard product={p} />
            </Col>
          ))}
        </Row>

        <div className="more-products">
          <a className="btn btn-view-more" href="/products" title="View more products">
            View More Products
          </a>
        </div>
      </Container>
    </section>
  );
}
